import { Modal } from "@sunrun/experience-ui-components";

type ConfirmRescheduleAppointmentModalProps = {
  testId: string;
  confirmRescheduleTestId: string;
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

const CONFIRM_RESCHEDULE_TITLE =
  "If you reschedule the appointment, the current one will be cancelled";

const ConfirmRescheduleAppointmentModal: React.FC<
  ConfirmRescheduleAppointmentModalProps
> = ({ testId, confirmRescheduleTestId, open, onConfirm, onClose }) => {
  if (!open) {
    return null;
  }

  return (
    <Modal
      testId={testId}
      title={CONFIRM_RESCHEDULE_TITLE}
      primaryButton={{
        text: "Reschedule",
        onClick: onConfirm,
        testId: confirmRescheduleTestId,
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: onClose,
      }}
      onClose={onClose}
    />
  );
};

export { ConfirmRescheduleAppointmentModal, CONFIRM_RESCHEDULE_TITLE };
export type { ConfirmRescheduleAppointmentModalProps };
